import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import { Mensaje, MensajeSiNo } from '../../mensajes2';

import { Dimmer } from "../../spinner";

import { formatoMonto, formatMoneda, seleccionarCampo, nmes, validaMonto, cmes } from '../../../util/varios';
import { suma, calculoMontoPagar } from '../../../util/OperacionesDeclaracion';
import { Table, TableBody, TableRow, TableCell } from '@mui/material'
    ;
import useTable from '../../useTable';

import axios from 'axios';
import moment from 'moment';

const headCells = [
    /* { id: '0', label: 'CODIGO', width: '80px', fontSize: "10px", textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
    */ { id: '1', label: 'DESCRIPCION DE LA ACTIVIDAD', width: '600px', fontSize: "10px", textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
    { id: '2', label: 'CODIGO ACTIVIDAD', width: '80px', fontSize: "10px", textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
    { id: '3', label: 'CODIGO CIU', width: '80px', fontSize: "10px", textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
    { id: '4', label: 'ALICUOTA(%)', width: '150px', fontSize: "10px", textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
    { id: '5', label: 'MINIMO TRIBUTABLE', width: '150px', fontSize: "10px", textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
    { id: '6', label: 'MONTO A DECLARADO', width: '150px', fontSize: "10px", textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
    { id: '7', label: 'MONTO EN BS.', width: '150px', fontSize: "10px", textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },
    { id: 'montode', label: 'MONTO EN U.C.', width: '150px', fontSize: "10px", textAlign: "center", backgroundColor: 'rgba(5, 81, 130, 1)', color: "white" },

]

export const TabActividadesDeclara = (props) => {

    /*  variables de estados */

    const btnCancela = useRef();
    const btnAcepta = useRef();
    const [mostrar, setMostrar] = useState(false);
    const [titulo, setTitulo] = useState();
    const [msg, setMsg] = useState();
    const [mostrar1, setMostrar1] = useState(false);
    const [titulo2, setTitulo2] = useState();
    const [msg2, setMsg2] = useState();
    const [activate, setActivate] = useState(false);
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });

    const [contar, setContar] = useState(0);
    const [contar2, setContar2] = useState(0);
    const [tecla, setTecla] = useState();
    const [indice, setIndice] = useState(0);


    const [operacion, setOperacion] = useState(0);

    const txtTotalDeclarado = useRef();
    const txtTotalPagar = useRef();
    const txtTotalPagarUC = useRef();

    const txtFechaDeclaracion = useRef();

    const txtDeclaradoRef = useRef([]);
    const [espiritu, setEspiritu] = useState(localStorage.getItem('espiritu'));
    const [fechaSistema, setFechaSistema] = useState(localStorage.getItem('fechasistema'));
    const [filterFn, setFilterFn] = useState({ fn: items => { return items; } })

    const idusuario = JSON.parse(localStorage.getItem('idusuario'))
    const [colocaFocus, setColocaFocus] = useState(false);
    const [datoUT, setDatoUT] = useState([]);
    const [records, setRecords] = useState();

    const {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting
    } = useTable(records, headCells, filterFn);


    const [montos, setMontos] = useState({
        impuesto: "0,00",
        intereses: "0,00",
        recargos: "0,00",
        retenciones: "0,00",
        credito: "0,00",
        acredit: "0,00",
        multa: "0,00",
    });

    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));
        setFechaSistema(obj.fechasistema);
        setEspiritu(obj.espiritu);
        if (props.operacion) {
            setOperacion(props.operacion);
        }

    }, [props.operacion]);

    let token = localStorage.getItem('jwtToken');
    let op = require('../../../../src/modulos/datos');

    const selectUT = (idcomercio, anio, mes, tipo, fecha, espiritu, totdeuda) => {

        let endpoint = `${op.conexion}/api/industria/valorut?idcomercio=${idcomercio}&anio=${anio}&mes=${mes}&tipo=${tipo}&fecha=${fecha}&espiritu=${espiritu}&totdeuda=${totdeuda}`;

        axios.get(endpoint, {
            headers: {
                "x-access-token": `${token}`,
                'Content-Type': 'application/json'

            },
        }).then(function (response) {

            if (response.status == 200) {
                setDatoUT(response.data);
                let data = [...records];
                var resu = [];
                resu = calculoMontoPagar(records, response.data, props.anio, props.tipodecla, espiritu);
                let totDec = parseFloat(0.00);
                let totPag = parseFloat(0.00);
                for (let i = 0; i < resu.length; i++) {
                    for (let x = 0; x < resu[i].activi.length; x++) {
                        data[x].montoapagar = resu[i].activi[x].montoapagar;
                        totDec += parseFloat(data[x].montodeclarado.replace(/\./g, '').replace(',', '.'));
                        totPag += parseFloat(data[x].montoapagar.replace(/\./g, '').replace(',', '.'));
                    }
                }
                if (response.data.mensaje !== '') {
                    setTitulo("Información");
                    setMsg(response.data.mensaje);
                    setMostrar(true);
                }
                setRecords(data);
                txtTotalDeclarado.current.value = formatMoneda(totDec.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
                txtTotalPagar.current.value = formatMoneda(totPag.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
            }

        }).catch(function (error) {

            setTitulo("ERROR");
            setMsg(error.response.data.message)
            setMostrar(true)
            setActivate(false);

        })

    }

    const handleCloseSi = () => {
        setMostrar1(false);
    };

    const handleCloseNo = () => {
        setMostrar1(false);
    };


    const handleCloseMensa = () => {
        setMostrar(false);
    }


    const handleInputMontoChange = (index) => (event) => {
        //event.preventDefault();
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which === 13 || typeof (event.which) === 'undefined') {
            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
            let char1 = event.target.value.substring(0, 1);
            let char2 = event.target.value.substring(1, 2);
            if (char1 === '0' && char2 !== ',') {
                event.target.value = event.target.value.substring(1, event.target.value.legth);
            }
            let data = [...records];
            let totDec = parseFloat(0.00);
            let totPag = parseFloat(0.00);
            let totPagUC = parseFloat(0.00);

            //data[index].montodeclarado = event.target.value;
            //data[index].montodeclarado = formatoMonto(event.target.value).replace(/\./g, '').replace(',', '.');



            let minimoParsed = parseFloat(data[index].minimo.toString().replace(/\./g, '').replace(',', '.'));
            let valueParsed = parseFloat(formatoMonto(event.target.value).replace(/\./g, '').replace(',', '.'));
            let factorCambio = parseFloat(props.factorCambio);

            data[index].montodeclarado = formatoMonto(event.target.value);


            setRecords(data);
            if (datoUT) {
                var resu = [];

                resu = calculoMontoPagar(records, datoUT, props.anio, props.tipodecla, espiritu);


                if (resu.length === 0) {
                    setMostrar(true);
                }
                for (let i = 0; i < resu.length; i++) {
                    setMontos({
                        impuesto: resu[i].impuesto,
                        intereses: resu[i].intereses,
                        recargos: resu[i].recargos,
                        retenciones: resu[i].retenciones,
                        credito: resu[i].credito,
                        acredit: resu[i].acredit,
                        multa: resu[i].multa,

                    });
                    for (let x = 0; x < resu[i].activi.length; x++) {
                        data[x].montoapagar = resu[i].activi[x].montoapagar;
                        data[x].montopetro = resu[i].activi[x].montopetro;
                        totDec += parseFloat(data[x].montodeclarado.replace(/\./g, '').replace(',', '.'));
                        totPag += parseFloat(data[x].montoapagar.replace(/\./g, '').replace(',', '.'));
                        totPagUC += parseFloat(data[x].montopetro);
                    }
                    txtTotalDeclarado.current.value = formatMoneda(totDec.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtTotalPagar.current.value = formatMoneda(totPag.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtTotalPagarUC.current.value = formatMoneda(totPagUC.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
                }

                /*for (let i = 0; i < resu.length; i++) {

                    setMontos({
                        impuesto: resu[i].impuesto,
                        intereses: resu[i].intereses,
                        recargos: resu[i].recargos,
                        retenciones: resu[i].retenciones,
                        credito: resu[i].credito,
                        acredit: resu[i].acredit,
                        multa: resu[i].multa,

                    });



                    for (let x = 0; x < resu[i].activi.length; x++) {

                        let minimoParsed = parseFloat(formatoMonto(resu[i].activi[x].minimo.toString()));
                        let valueParsed = parseFloat(formatoMonto(resu[i].activi[x].montodeclarado).replace(/\./g, '').replace(',', '.'));
                        let factorCambio = parseFloat(props.factorCambio);
                        let alicuota = parseFloat(formatoMonto(resu[i].activi[x].alicuota.toString()));


                        //monto del valor ingresado por el porcentaje de la alicuota
                        //let montoAliValue = parseFloat(valueParsed) / 100 * parseFloat(alicuota)
                        let montoAliValue = parseFloat(valueParsed) / 100 * parseFloat(alicuota)


                        //monto del valor montoAliValue dividido por el facotr cambio 
                        let montoAliValueFac = parseFloat(montoAliValue) / parseFloat(factorCambio)


                        //monto del minimo multiplicado por el factor cambio
                        let montoMinFac = parseFloat(minimoParsed) * parseFloat(factorCambio)




                        if (parseFloat(montoAliValueFac) > parseFloat(minimoParsed)) {
                            data[x].montopetro = montoAliValueFac
                            data[x].montoapagar = formatMoneda(montoAliValue.toString().replace(',', '').replace('.', ','), ',', '.', 2);

                        } else {
                            data[x].montopetro = resu[i].activi[x].montopetro;
                            data[x].montoapagar = formatMoneda(montoMinFac.toString().replace(',', '').replace('.', ','), ',', '.', 2);

                        }
                        totDec += parseFloat(data[x].montodeclarado.replace(/\./g, '').replace(',', '.'));
                        totPag += parseFloat(data[x].montoapagar.replace(/\./g, '').replace(',', '.'));
                        //totPagUC += parseFloat(data[x].montopetro.replace(/\./g, '').replace(',', '.'));
                        totPagUC += parseFloat(data[x].montopetro);

                    }
                    txtTotalDeclarado.current.value = formatMoneda(totDec.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtTotalPagar.current.value = formatMoneda(totPag.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtTotalPagarUC.current.value = formatMoneda(totPagUC.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
                }*/

                setRecords(data);

                event.target.value = (formatoMonto(event.target.value));



            }

            if (event.which === 13) {
                if (index + 1 === txtDeclaradoRef.current.length) {
                    //txtDeclaradoRef.current[index].focus();
                    btnAcepta.current.focus();
                    setColocaFocus(true);
                } else {
                    txtDeclaradoRef.current[index + 1].focus();
                    setColocaFocus(false);
                }
            } else {
                setColocaFocus(false);
            }


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);

    };

    const handleInputFechaChange = (event) => {

        if (event.which === 13 || typeof (event.which) === 'undefined') {
            selectUT(parseInt(props.idcomercio, 10), props.anio, props.nmes, props.tipodecla, txtFechaDeclaracion.current.value === "" ? fechaSistema : txtFechaDeclaracion.current.value, espiritu, props.totdeuda);


        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };



    const onChangeValidar = () => {
        var sigue = true;
        if (txtFechaDeclaracion.current.value.trim() === '') {
            setTitulo('Error');
            setMsg('Debe Introducir la Fecha de Declaración');
            sigue = false;
            txtFechaDeclaracion.current.focus();
        }
        if (sigue) {
            var axc = [];
            for (let i = 0; i < records.length; i++) {

                axc.push({
                    alicuota: records[i].alicuota,
                    codigoactividad: records[i].codigoactividad,
                    codigociu: records[i].codigociu,
                    descripcion: records[i].descripcion,
                    idactividad: records[i].idactividad,
                    minimo: records[i].minimo,
                    montodeclarado: records[i].montodeclarado.replace(/\./g, '').replace(',', '.').toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    montoapagar: records[i].montoapagar.replace(/\./g, '').replace(',', '.').toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
                    montopetro: records[i].montopetro,
                    fechadeclaracion: txtFechaDeclaracion.current.value
                });

            }
            setRecords();
            props.onHideAcepta(axc);
            //procesarDeclaracion(axc)
        } else {
            setMostrar(true);
        }

    };

    const cancelar = () => {
        setRecords();
        props.onHideCancela();
    }

    const cerrarModal = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })
        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })

        props.onHideCancela()
    }

    return (
        <Modal
            {...props}
            size="xl"
            aria-labelledby="contained-modal-title-vcenter"
            style={{ backgroundColor: 'rgb(28, 27, 23,0.4)' }}
            centered
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
                if (props.tabactixcomer && txtTotalDeclarado.current) {


                    let tabactixcomer = []
                    var suma = 0;
                    var montpagar = 0;
                    let minimo = 0;
                    let factorCambio = 0;
                    let pagar = 0;
                    let uc = 0;
                    let alicuota = 0;
                    for (let i = 0; i < props.tabactixcomer.length; i++) {

                        minimo = parseFloat(props.tabactixcomer[i].minimo.replace(',', '.'));
                        alicuota = parseFloat(props.tabactixcomer[i].alicuota.replace(',', '.'));
                        factorCambio = parseFloat(props.factorCambio.replace(',', '.'));
                        //pagar = (minimo * factorCambio).toFixed(2); // Redondear a 2 decimales
                        uc = pagar / factorCambio;
                        if (props.tipodecla === '2') {
                            //if (parseInt(espiritu) === 11 || parseInt(espiritu) === 2 || parseInt(espiritu) === 1 || parseInt(espiritu) === 0) {
                            if (parseInt(espiritu) === 13 || parseInt(espiritu) === 11 || parseInt(espiritu) === 2 || parseInt(espiritu) === 1 ||  parseInt(espiritu) === 0 ||  parseInt(espiritu) === 12 || parseInt(espiritu) === 14) {
                                if (pagar < minimo * factorCambio) {
                                    pagar = (minimo * factorCambio).toFixed(2);
                                    uc = minimo;
                                }
                            } else {
                                if (pagar < minimo * factorCambio) {
                                    pagar = (minimo * factorCambio).toFixed(2);
                                    uc = minimo;
                                }
                            }
        
                        } else if (props.tipodecla === '3' || props.tipodecla === '4') {
                            //if (parseInt(espiritu) === 11 || parseInt(espiritu) === 2 || parseInt(espiritu) === 1 || parseInt(espiritu) === 0) {
                            if (espiritu !== 9) {
                                if (pagar < minimo / 2 * factorCambio) {
                                    pagar = (minimo / 2 * factorCambio).toFixed(2);
                                    uc = minimo/2;
                                }
                            } else {
                                if (pagar < minimo * factorCambio) {
                                    pagar = (minimoAnual / 2 * factorCambio).toFixed(2);
                                    uc = minimo/2;
                                }
                            }
                        } else {
                            if (pagar < minimo * factorCambio) {
                                pagar = (minimo * factorCambio).toFixed(2);
                                uc = minimo;
                            }
                        }


                        tabactixcomer.push({
                            alicuota: props.tabactixcomer[i].alicuota,
                            codigoactividad: props.tabactixcomer[i].codigoactividad,
                            codigociu: props.tabactixcomer[i].codigociu,
                            descripcion: props.tabactixcomer[i].descripcion,
                            idactividad: props.tabactixcomer[i].idactividad,
                            minimo: minimo.toFixed(2), // Redondear a 2 decimales
                            montoapagar: formatMoneda(pagar.toString().replace('.', ','), ',', '.', 2),
                            montodeclarado: props.tabactixcomer[i].montodeclarado,
                            montopetro: uc.toFixed(2) // Redondear a 2 decimales
                        });

                        suma += parseFloat(uc);
                        montpagar += parseFloat(pagar)
                    }



                    txtTotalPagarUC.current.value = formatMoneda(suma.toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    txtTotalPagar.current.value = formatMoneda(montpagar.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);


                    setRecords(tabactixcomer)
                    setDatoUT(props.datoCalculo);
                    var resu = [];
                    //resu = suma(props.tabactixcomer, props.anio, props.mes, props.datoCalculo, props.tipodecla, espiritu);
                    resu = calculoMontoPagar(props.tabactixcomer, props.datoCalculo, props.anio, props.tipodecla, espiritu);
                    let totDec = parseFloat(0.00);
                    let totPag = parseFloat(0.00);
                    let totPagUC = parseFloat(0.00);

                    for (let i = 0; i < resu.length; i++) {
                        for (let x = 0; x < resu[i].activi.length; x++) {

                            totDec += parseFloat(resu[i].activi[x].montodeclarado.replace(/\./g, '').replace(',', '.'));
                            totPag += parseFloat(resu[i].activi[x].montoapagar.replace(/\./g, '').replace(',', '.'));
                            //totPagUC += parseFloat(resu[i].activi[x].montopetro.replace(/\./g, '').replace(',', '.'));
                            totPagUC += parseFloat(resu[i].activi[x].montopetro);

                        }
                        txtTotalDeclarado.current.value = formatMoneda(totDec.toFixed(2).toString().replace(',', '').replace('.', ','), ',', '.', 2);
                    }
                }
            }}

        >
            <Modal.Header className='azulGradiant'>
                {operacion === 1 ? 'Agregar Actividad.' : operacion === 2 ? 'Editar Actividad.' : operacion === 3 ? 'Eliminar Actividad.' : 'Consultar Actividad.'}
                {/*<button ref={btnCancela} className="btn" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>*/}
            </Modal.Header>
            <Modal.Body  >
                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />

                <Dimmer active={activate} inverted>

                </Dimmer>
                <div className="row col-md-12 tipo-letra mb-1" >
                    <div className="col-md-8 text-left fw-bold my-auto">
                        <label htmlFor="inputRitm" >{'DECLARACION JURADA ' + (props.tipodecla === '3' ? ' 1ERA. QUINCENA ' : props.tipodecla === '4' ? ' 2DA. QUINCENA ' : '') + props.mes + '-' + props.anio} </label>
                    </div>
                    <div className="row col-md-3 my-auto ml-auto">

                        <div className="input-group input-group-sm mb-3 col-md-12">
                            <span className="input-group-text" id="inputGroup-sizing-sm"> Fecha:</span>
                            <input ref={txtFechaDeclaracion} type="date" className="form-control form-control-sm" id="inputFechaNac" max={moment.utc(fechaSistema).format('YYYY-MM-DD')} defaultValue={moment.utc(fechaSistema).format('YYYY-MM-DD')} onKeyUp={handleInputFechaChange} onBlur={handleInputFechaChange} />
                        </div>


                    </div>
                </div>

                <div className='mx-auto row px-0'>

                    <TblContainer>
                        <TblHead />
                        <tbody>
                            {records && records.map((post1, index) => (

                                post1.idactividad === '' ? '' :

                                    <tr key={post1.idactividad} >
                                        {/*   <td style={{ fontSize: '14px', textAlign: "center" }}>{post1.codigociu}</td>
                                          */}   <td style={{ fontSize: '14px' }}>{post1.descripcion}</td>
                                        <td style={{ fontSize: '14px', textAlign: "center" }}>{post1.codigoactividad}</td>
                                        <td style={{ fontSize: '14px', textAlign: "center" }}>{post1.codigociu}</td>

                                        <td style={{ fontSize: '14px' }}><input type="text" name={"ali" + post1.idactividad} defaultValue={formatMoneda(post1.alicuota.replace(',', '').replace('.', ','), ',', '.', 2)} style={{ width: "80px", textAlign: "right", fontSize: "11" }} disabled className="form-control text-uppercase" /></td>

                                        <td style={{ fontSize: '14px', textAlign: "right" }}>{formatMoneda(post1.minimo.toString().replace(',', '').replace('.', ','), ',', '.', 4)}</td>


                                        <td style={{ fontSize: '14px' }}><input ref={el => txtDeclaradoRef.current[index] = el} type="text" autoComplete="off" name={post1.idactividad} defaultValue={post1.montodeclarado} style={{ width: "140px", textAlign: "right", fontSize: "10" }} onFocus={seleccionarCampo} onKeyUp={handleInputMontoChange(index)} onBlur={handleInputMontoChange(index)} className="form-control text-uppercase" /></td>

                                        <td style={{ fontSize: '14px' }}><input type="text" name={"total" + post1.idactividad} value={post1.montoapagar} style={{ width: "140px", textAlign: "right", fontSize: "10" }} disabled className="form-control text-uppercase" /></td>

                                        <td style={{ fontSize: '14px' }}><input type="text" name={"total" + post1.idactividad} value={formatMoneda(post1.montopetro.toString().replace(',', '').replace('.', ','), ',', '.', 2)} style={{ width: "140px", textAlign: "right", fontSize: "10" }} disabled className="form-control text-uppercase" /></td>

                                    </tr>
                            ))}
                        </tbody>

                    </TblContainer>
                    <div className='col-md-8'></div>
                    <div className='col-md-4 mt-0'>
                        <div className="input-group input-group-sm col-md-12 px-0 my-0 w-100">
                            <span className="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Total Declarado:</span>

                            <input type="text" readOnly ref={txtTotalDeclarado} style={{ textAlign: 'right' }} className="form-control form-control-sm bg-light bg-transparent border-0" id="inputTotalDeclarado" defaultValue="0,00" />



                        </div>
                        <div className="input-group input-group-sm col-md-12 px-0 my-0 w-100">
                            <span className="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Total a Pagar Bs:</span>


                            <input type="text" readOnly ref={txtTotalPagar} style={{ textAlign: 'right' }} className="form-control form-control-sm bg-light bg-transparent border-0" id="inputTotalPagar" defaultValue="0,00" />


                        </div>
                        <div className="input-group input-group-sm col-md-12 px-0 my-0 w-100">
                            <span className="input-group-text border-0 bg-transparent" id="inputGroup-sizing-sm">Total a Pagar UC:</span>

                            <input type="text" readOnly ref={txtTotalPagarUC} style={{ textAlign: 'right' }} className="form-control form-control-sm bg-light bg-transparent border-0" id="inputTotalPagar" defaultValue="0,00" />

                        </div>
                    </div>


                </div>
                <div className="row col-md-12">

                    <div className='col-md-6'></div>



                </div>

            </Modal.Body>
            <Modal.Footer>
                <button ref={btnAcepta} onClick={onChangeValidar} className="btn btn-sm btn-success rounded-pill col-md-2"><i className="fas fa-check-circle">  Aceptar</i></button>
                <button ref={btnCancela} onClick={cancelar} className="btn btn-sm btn-danger rounded-pill col-md-2"><i className="fas fa-window-close"> Cancelar</i></button>
            </Modal.Footer>
        </Modal>
    );
}